export interface ISupportStaffRole {
  supportStaffRoleId: number;
    name: string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ISupportStaffRole = {
  getDefault(): ISupportStaffRole {
    return {
      supportStaffRoleId: 0,
        name: '',
    };
  },
};
